import {formatMonetaryToBr} from '../../../../../utils/formatMonetaryToBr'

export type TItemValidateForm = {
  seller: AllUsersResponse[]
  category: number
  type: number
  qtd: number
  product: number
  value: number
  packagePrice: number
  discount: string
  discountMaxProduct: string
}
type AllUsersResponse = {
  value: string
  label: string
}

export type TitemRequest = {
  item: number
  seller: number
}[]

export const createInitialValues: TItemValidateForm = {
  seller: [],
  category: 0,
  type: 0,
  qtd: 0,
  product: 0,
  value: 0,
  packagePrice: 0,
  discount: formatMonetaryToBr('0'),
  discountMaxProduct: '',
}
